export default [{
    text: '1 месяц',
    value: 1,
}, {
    text: '2 месяца',
    value: 2,
}, {
    text: '3 месяца',
    value: 3,
}, {
    text: '4 месяца',
    value: 4,
}, {
    text: '5 месяцев',
    value: 5,
}, {
    text: '6 месяцев',
    value: 6,
}, {
    text: '7 месяцев',
    value: 7,
}, {
    text: '8 месяцев',
    value: 8,
}, {
    text: '9 месяцев',
    value: 9,
}, {
    text: '10 месяцев',
    value: 10,
}, {
    text: '11 месяцев',
    value: 11,
}, {
    text: '1 год',
    value: 12,
}];
